import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const { user, ready, setUser } = useAuth();
  const nav = useNavigate();
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && !user) { nav("/login"); return null; }
  const first = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (np.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (np !== cp) return toast.error("As senhas não coincidem");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-password", { new_password: np });
      setUser(data.user);
      toast.success("Senha atualizada!");
      nav(data.user.role === "superadmin" ? "/admin" : "/painel");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#141417] border border-white/10 rounded-3xl p-7" data-testid="change-password-form">
        <h1 className="font-head text-2xl font-extrabold">{first ? "Crie sua nova senha" : "Trocar senha"}</h1>
        <p className="text-sm text-zinc-500 mt-1 mb-6">{first ? "Por segurança, defina uma nova senha para o primeiro acesso." : "Defina uma nova senha de acesso."}</p>
        <label className="text-xs font-semibold text-zinc-400">Nova senha</label>
        <input value={np} onChange={(e) => setNp(e.target.value)} type="password" required data-testid="new-password"
          className="w-full mt-1 mb-4 rounded-xl bg-white/[0.04] border border-white/10 px-4 py-3 outline-none focus:border-[#FF6B00]" placeholder="••••••••" />
        <label className="text-xs font-semibold text-zinc-400">Confirmar senha</label>
        <input value={cp} onChange={(e) => setCp(e.target.value)} type="password" required data-testid="confirm-password"
          className="w-full mt-1 mb-6 rounded-xl bg-white/[0.04] border border-white/10 px-4 py-3 outline-none focus:border-[#FF6B00]" placeholder="••••••••" />
        <button disabled={loading} data-testid="change-password-submit" className="w-full rounded-full bg-[#FF6B00] py-3.5 font-bold text-white orange-glow disabled:opacity-60">{loading ? "Salvando..." : "Salvar senha"}</button>
      </form>
    </div>
  );
}
